import { Component, OnInit, Signal } from '@angular/core';
import { ContentComponent } from '../../components/content/content.component';
import { Store } from '@ngrx/store';
import { selectServices } from '../../store/selectors/app.selectors';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AlertComponent } from '../../common/alert/alert.component';
import { FilterDataPipe } from '../../pipes/filter-data.pipe';
import { BreadcrumbsComponent } from '../../common/breadcrumbs/breadcrumbs.component';
import { ServiceListItem } from '../../services/service.common.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-e-services-page',
  standalone: true,
  imports: [
    ContentComponent,
    RouterModule,
    CommonModule,
    FormsModule,
    AlertComponent,
    FilterDataPipe,
    BreadcrumbsComponent
  ],
  templateUrl: './e-services-page.component.html'
})
export class EServicesPageComponent implements OnInit {
  public services: Signal<ServiceListItem[] | undefined> =
    toSignal<ServiceListItem[]>(this.store$.select(selectServices).pipe(map(v => v.filter(s => !s?.isCaseRelated))));

  private query: string | undefined =
    this.route.snapshot.queryParams?.['query'];

  public filterValue: string = '';

  constructor(private store$: Store, private route: ActivatedRoute) {
  }

  public ngOnInit(): void {
    this.filterValue = this.query || '';
  }
}
